import { useLocation, useNavigate } from "react-router-dom";
import { useT } from "@/i18n/LangProvider";
import { DEFAULT_LANG } from "@/i18n/translations";

const KNOWN_LANGS = ["de", "pt", "en"];

/** Build a URL path prefixed with the active language when non-default. */
export function langPrefix(lang) {
  return lang && lang !== DEFAULT_LANG ? `/${lang}` : "";
}

/** Returns the localized href for the quote form. */
export function useQuoteHref() {
  const { lang } = useT();
  return `${langPrefix(lang)}/orcamento`;
}

/** Returns the localized href for the home page. */
export function useHomeHref() {
  const { lang } = useT();
  return `${langPrefix(lang)}/` || "/";
}

/**
 * Returns a function that switches the app language AND updates the URL so
 * the new prefix (/pt, /en, or nothing for DE) reflects the active language,
 * while preserving the current sub-path (e.g. "/orcamento").
 */
export function useSwitchLang() {
  const { setLang } = useT();
  const navigate = useNavigate();
  const loc = useLocation();

  return (nextLang) => {
    setLang(nextLang);
    const segments = loc.pathname.split("/").filter(Boolean);
    const subPath = KNOWN_LANGS.includes(segments[0])
      ? segments.slice(1)
      : segments;
    const rest = subPath.length ? `/${subPath.join("/")}` : "";
    const target = `${langPrefix(nextLang)}${rest}` || "/";
    navigate(target, { replace: false });
  };
}
